// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"content-block-module--content-block--XLnPD","heading":"content-block-module--heading--18njI","text":"content-block-module--text--rHUmG"};